import { Skeleton } from '@/components/Skeleton'

export const AppLoadingState = () => {
    return (
        <div className="bg-account-page text-account-strong min-h-screen font-sans">
            <div className="border-account-divider border-b">
                <div className="mx-auto flex max-w-3xl items-center justify-between gap-4 px-4 py-5 sm:px-6 sm:py-6">
                    <div className="flex min-w-0 items-center gap-3">
                        <Skeleton className="h-10 w-10 shrink-0 rounded-full" />
                        <div className="min-w-0 flex-1 space-y-2">
                            <Skeleton className="h-5 w-28" />
                            <Skeleton className="h-3 w-40 max-w-full" />
                        </div>
                    </div>

                    <Skeleton className="h-4 w-20 shrink-0" />
                </div>
            </div>
            <main className="mx-auto max-w-3xl space-y-3 px-4 py-7 sm:px-6 sm:py-10">
                <Skeleton className="h-8 w-64 max-w-full" />
                <Skeleton className="h-4 w-80 max-w-full" />
            </main>
        </div>
    )
}
